var ProductDetailApp = (function ($, Vue) {
    'use strict';

    var config = {
        bagProductLocalStorageKey: 'huntstreet_bag_product_codes'
    };

    var vProductDetail;

    function initCarousels() {
        if (typeof ProductDetailConfig === 'undefined') return;

        var productCurationSplideOption = {
            perPage: ProductDetailConfig.perPageCarousel,
            perMove: 1,
            pagination: false,
            breakpoints: {
                '768': {perPage: 3.5},
                '480': {perPage: 2.5}
            }
        };

        if ($('#related-products').length) {
            if (ProductDetailConfig.isMustLoopRelated) {
                productCurationSplideOption.type = 'loop';
            }
            new Splide('#related-products', productCurationSplideOption).mount();
        }

        if ($('#recent-products').length) {
            productCurationSplideOption.type = 'slide';
            if (ProductDetailConfig.isMustLoopRecent) {
                productCurationSplideOption.type = 'loop';
            }
            new Splide('#recent-products', productCurationSplideOption).mount();
        }
    }

    function initAccordion() {
        $('.accordionWrapper .accordionRow .accordionHeading').on('click', function () {
            $(this).parent('.accordionRow').toggleClass('active');
        });

        $('.accordionWrapper .accordionRow .accordionContent ul').removeClass('ui-tabs-nav ui-helper-reset ' +
            'ui-helper-clearfix ui-widget-header ui-corner-all');
    }

    function initImageSlider() {
        if ($('#flexslider').length > 0) {
            $('#flexslider').bxSlider({
                mode: 'horizontal',
                pagerCustom: '#flexcarousel',
                controls: true,
                auto: false,
                touchEnabled: false,
                onSliderLoad: function () {
                    $('#flexslider li').css('visibility', 'visible');
                }
            });
        }

        if ($('#tabs').length > 0) {
            $('#tabs').tabs();
        }

        if ($('#tabsSlider').length > 0 && $(window).width() < 960) {
            $('#tabsSlider').owlCarousel({
                items: 1,
                autoWidth: true,
                margin: 10,
                pagination: false
            });
        }

        if ($('#itemsSlider').length > 0 && $(window).width() > 959) {
            var owl = $('#itemsSlider');
            owl.owlCarousel({
                autoWidth: true,
                margin: 10,
                pagination: false
            });

            $('.prevBtn').click(function () {
                owl.trigger('prev.owl.carousel');
                return false;
            });

            $('.nextBtn').click(function () {
                owl.trigger('next.owl.carousel');
                return false;
            });
        } else if ($('#itemsSlider').length > 0) {
            $('#itemsSlider').attr('id', '');
        }
    }

    function initImageZoom() {
        $('#flexslider li').click(function () {
            $('body, html').css('overflow', 'hidden');
            $('.image_zoom_container').show();
            ProductDetailApp.displayDetailedImage(this);
        });

        $('.image_thumbnail ul li').click(function () {
            ProductDetailApp.displayDetailedImage(this);
        });

        $('.image_zoom_container .close').click(function () {
            $('.image_zoom_container').fadeOut();
            $('body, html').css('overflow', 'scroll');
        });

        $('.productImageWrapper .flexThumbnailsBox .nav').click(function () {
            var scrollAmount = $(this).hasClass('nav--top') ? '-=160px' : '+=160px';
            $(".productImageWrapper .flexThumbnailsBox .flexCarouselBox").animate({
                scrollTop: scrollAmount
            }, 200);
        });
    }

    function initImageHoverSwap() {
        $(document).on('mouseenter', '.product-image-hover', function () {
            var secondImage = $(this).data('second-image');
            if (secondImage) {
                $(this).data('first-image', $(this).attr('src'));
                $(this).attr('src', secondImage);
            }
        });

        $(document).on('mouseleave', '.product-image-hover', function () {
            var firstImage = $(this).data('first-image');
            if (firstImage) {
                $(this).attr('src', firstImage);
            }
        });
    }

    function initStarRating() {
        var starRatingOption = {
            initialRating: 0,
            useGradient: false,
            activeColor: '#A47B24',
            strokeColor: '#A47B24',
            strokeWidth: 5,
            starSize: screen.width < 768 ? 12 : 18,
            readOnly: true
        };

        var ratings = [
            {class: '.noRateStar', rating: 0, size: screen.width < 768 ? 12 : 14},
            {class: '.rateStar.one', rating: 1},
            {class: '.rateStar.one-half', rating: 1.5},
            {class: '.rateStar.two', rating: 2},
            {class: '.rateStar.two-half', rating: 2.5},
            {class: '.rateStar.three', rating: 3},
            {class: '.rateStar.three-half', rating: 3.5},
            {class: '.rateStar.four', rating: 4},
            {class: '.rateStar.four-half', rating: 4.5},
            {class: '.rateStar.five', rating: 5}
        ];

        ratings.forEach(function (r) {
            var options = Object.assign({}, starRatingOption, {initialRating: r.rating});
            if (r.size) {
                options.starSize = r.size;
            }
            $(r.class).starRating(options);
        });
    }

    function init() {
        if ($('#product-detail').length > 0) {
            vProductDetail = new Vue({
                el: '#product-detail',
                data: {
                    isLoadingAddToViewingRequest: false,
                    isLoadingAddToBag: false,
                    huntlistProducts: [],
                    isLoadingSellerAvailability: false,
                    isRequestAskAvailability: false,
                },
                created: function () {
                    if (typeof ProductDetailConfig !== 'undefined' && ProductDetailConfig.isUserLoggedIn) {
                        this.getHuntlistProducts();
                    }
                },
                methods: {
                    askSellerAvailability: function (isLogin) {
                        if (!isLogin) {
                            alert('Must login first to ask Availability.');
                            return false;
                        }

                        this.isLoadingSellerAvailability = true;
                        var _self = this;

                        this.$http.post(ProductDetailConfig.askProductAvailabilityUrl).then(function (success) {
                            if (success.ok) {
                                alert('Your Availability Request is sent. We will inform you via whatsapp or email soon.');
                            }

                            _self.isLoadingSellerAvailability = false;
                            _self.isRequestAskAvailability = true;
                        }, function (error) {
                            alert('You can\'t ask availability for your own item');
                            _self.isLoadingSellerAvailability = false;
                        });
                    },
                    addToViewingRequest: function () {
                        this.isLoadingAddToViewingRequest = true;

                        var _self = this;

                        this.$http.post(ProductDetailConfig.addToViewingRequestUrl, {product_code: ProductDetailConfig.productCode}).then(function (success) {
                            if (success.ok) {
                                var viewingRequest = success.data;

                                $('.viewingRequest.desktop #header-viewing-request-item-total').html(viewingRequest.total_items);
                                $('.viewingRequestWrapper.desktop #header-viewing-request-item-content').html(viewingRequest.items_view_content);
                                $('.loginWrapper.desktop').hide();
                                $('.myBagWrapper.desktop').hide();
                                $('.viewingRequestWrapper.desktop').fadeIn();
                            }

                            _self.isLoadingAddToViewingRequest = false;
                        }, function (error) {
                            console.log(error);
                            _self.isLoadingAddToViewingRequest = false;
                        });
                    },
                    addToBag: function (isShouldRedirect) {
                        if (typeof isShouldRedirect === 'undefined') {
                            isShouldRedirect = false;
                        }

                        this.isLoadingAddToBag = true;

                        var _self = this;
                        var bagProductCodes = JSON.parse(localStorage.getItem(config.bagProductLocalStorageKey)) || [];

                        this.$http.post(ProductDetailConfig.addToBagUrl, {product_code: ProductDetailConfig.productCode}).then(function (success) {
                            if (success.ok) {
                                var bag = success.data;

                                $('#product-detail .buttonBox').html('<a href="#" onclick="return false" class="button button-full button-secondary">On Hold</a>');
                                $('.myBag.desktop #header-bag-item-total').html(bag.item_total);
                                $('.myBagWrapper.desktop #header-bag-item-content').html(bag.item_view_content);
                                $('.loginWrapper.desktop').hide();
                                $('.viewingRequestWrapper.desktop').hide();
                                $('.myBagWrapper.desktop').fadeIn();

                                dataLayer.push({'event': 'added-to-cart'});

                                if (!bagProductCodes.includes(ProductDetailConfig.productCode)) {
                                    bagProductCodes.push(ProductDetailConfig.productCode);
                                }

                                localStorage.setItem(config.bagProductLocalStorageKey, JSON.stringify(bagProductCodes));
                            }

                            _self.isLoadingAddToBag = false;

                            if (isShouldRedirect) {
                                window.location.href = ProductDetailConfig.redirectToBagUrl;
                            }
                        }, function (error) {
                            alert(error.data.error.message);
                            _self.isLoadingAddToBag = false;
                        });
                    },
                    getHuntlistProducts: function () {
                        var _self = this;

                        this.$http.get(ProductDetailConfig.huntlistUrl).then(function (success) {
                            if (success.ok) {
                                _self.huntlistProducts = success.data;
                            } else {
                                console.log("Error when get huntlist products.");
                            }
                        }, function (error) {
                            var data = error.data;

                            if (error.status === 500) {
                                alert(data.error.message);
                            } else {
                                console.log(data);
                            }
                        });
                    },
                    like: function (productCode, event) {
                        if (typeof event !== 'undefined') {
                            var button = $(event.target);
                            button.attr('disabled', 'disabled');
                            button.addClass('loading');
                        }

                        var _self = this;
                        var isWatch = !this.huntlistProducts.includes(productCode.toString());

                        this.doWatch(productCode, isWatch, function () {
                            if (typeof event !== 'undefined') {
                                var button = $(event.target);
                                button.removeAttr('disabled');
                                button.removeClass('loading');
                            }

                            _self.getHuntlistProducts();
                        });
                    },
                    doWatch: function (productCode, is, postWatch) {
                        this.$http.post(ProductDetailConfig.restockUrl, {
                            code: productCode,
                            watch: is
                        }).then(function (success) {
                            postWatch(success);
                        }, function (error) {
                            alert(error.data.error.message);
                        });
                    }
                }
            });

            initCarousels();
            initAccordion();
            initImageSlider();
            initImageZoom();
            initImageHoverSwap();
            initStarRating();

            new Clipboard('#copy-item-link');
        }
    }

    function displayDetailedImage(el) {
        var src = $(el).find('img').data('low-src');
        var originalSrc = $(el).find('img').data('original-src');

        $('.image_zoom_box img').attr('src', '');
        $('.image_zoom_box').css('background', 'url(' + src + ') no-repeat center center');
        $('.image_zoom_box').css('background-size', 'cover');
        $('.image_zoom_box img').attr('src', originalSrc);
    }

    return {
        init: init,
        getInstance: function () {
            return vProductDetail;
        },
        displayDetailedImage: displayDetailedImage
    };
})(jQuery, Vue);

function shareOnWhatsapp(param) {
    var url = 'https://api.whatsapp.com/send?text=' + param;
    window.open(url, '_blank');
    return false;
}

function shareOnFacebook(param) {
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + param;
    window.open(url, '_blank');
    return false;
}

function shareOnTwitter(param) {
    var url = 'https://twitter.com/intent/tweet?url=' + param;
    window.open(url, '_blank');
    return false;
}
